import React from 'react';
import Hero from '../components/hero';
import Layout from '../components/Layout';

export default function HomePage() {
  return (
    <div>
      <Layout>
        <Hero />
        <h2>UPCOMING RITUALS</h2>
      </Layout>
    </div>
  );
}
